module.exports = __webpack_public_path__ + "img/transflo-express-no.f97dc0a3.svg";